// extracted by mini-css-extract-plugin
export default {"select":"wNHel","selectedOverlay":"JrUYW","option":"cGpUH","optionSelected":"ISp71","optionIcon":"li0yd","optionTitle":"c3nSa"};